import _isEmpty from "lodash/isEmpty";
import _every from "lodash/every";
import { TOKENS } from "../constants/general.constants";
import { get, map } from "lodash";
import axios, { BASE_URL } from "../axios";
import { every, isEmpty } from "lodash";
import { toast } from "react-toastify";
import { userActions } from "../actions";

export const validateEmptyField = (value, id) => {
  if (_isEmpty(value)) return `${id} can not be empty`;
  return "";
};

export const validatePassword = (password) => {
  const passwordRegex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
  return password.match(passwordRegex)
    ? ""
    : "password must contain at least 6 characters, including Upper/lowercase and numbers";
};

export const isEmptyError = (error) =>
  _every(error, (value) => _isEmpty(value));

export const getRandomColor = () => {
  const randomIndex = Math.floor(Math.random() * 20);
  const colors = [
    "#BC589A",
    "#2522B9",
    "#137149",
    "#917D4B",
    "#58AABC",
    "#BC5858",
    "#2270B9",
    "#711913",
    "#F35B04",
    "#7678EC",
    "#BC589A",
    "#2522B9",
    "#137149",
    "#917D4B",
    "#58AABC",
    "#BC5858",
    "#2270B9",
    "#711913",
    "#F35B04",
    "#7678EC",
  ];
  return colors[randomIndex];
};

export const LOCAL_STORAGE = {
  TOKEN: "token",
};

export const getParsedTokenData = (string) => {
  try {
    return JSON.parse(string);
  } catch (e) {
    return "";
  }
};

export const getToken = () => {
  const token = localStorage.getItem(TOKENS.ACCESS_TOKEN);

  return token;
};

export const getRefreshToken = () => {
  const token = localStorage.getItem(TOKENS.REFRESH_TOKEN);
  return token;
};

export const handleError = (error) => {
  const { response } = error;
  const { data } = response;
  const { message } = data;
  return message;
};

export const getFormattedPlaylists = (playlists) => {
  return playlists.map((playlist) => {
    return {
      ...playlist,
      color: getRandomColor(),
      songs: map(playlist.songs, (song) => {
        return {
          ...song,
          color: getRandomColor(),
        };
      }),
    };
  });
};

export const getFormattedSong = (song) => {
  return {
    ...song,
    url: `${BASE_URL}/media/${song.audio_track}`,
    color: getRandomColor(),
    thumbnail_img: !song?.thumbnail_img
      ? ""
      : `${BASE_URL}/media/${song.thumbnail_img}`,
  };
};

export const getFormattedSongs = (songs) =>
  map(songs, (item) => getFormattedSong(item));

export const validateEmail = (value) => {
  const emailRegex =
    // eslint-disable-next-line max-len, no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value) ? "" : "Please enter valid Email";
};

//this function will validate password

export const validateConfirmPassword = (password, confirmPassword) => {
  if (password !== confirmPassword) {
    return "Password and confirm password does not match";
  }
  return "";
};
export const isEmptyErrors = (errors) =>
  every(errors, (value) => isEmpty(value));

//*valoidate username;
export const toaster = (type, message) => {
  const validTypes = ["error", "success", "warning", "info"];
  if (typeof message !== "string" || !validTypes.includes(type)) {
    throw new Error("Invalid arguments");
  }
  toast[type](message);
};

export const validateDate = (date) => {
  // Regex for date format yyyy-mm-dd
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  // Convert Date object to string in yyyy-mm-dd format
  const dateString =
    date instanceof Date ? date.toISOString().split("T")[0] : date;

  // Validate the date string
  return dateString.match(dateRegex)
    ? ""
    : "Enter valid date in yyyy-mm-dd format";
};

//convert date to 20, Feb 2023 this formate
export const convertDate = (date) => {
  const d = new Date(date);
  const month = d.toLocaleString("default", { month: "short" });
  return `${d.getDate()}, ${month} ${d.getFullYear()}`;
};

//convert timestamp duration to min and sec
export const convertDuration = (duration) => {
  const min = Math.floor(duration / 60);
  const sec = duration % 60;
  return `${min}:${sec}`;
};

export const convertToTwoDigit = (value) => (value < 10 ? `0${value}` : value);

export const formatDateAccordingToDateType = (date, type) => {
  if (!date) return;

  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const month =
    date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const year = date.getFullYear();

  switch (type) {
    case "dd/mm/yyyy":
      return `${day}/${month}/${year}`;
    case "mm/dd/yyyy":
      return `${month}/${day}/${year}`;
    case "yyyy/mm/dd":
      return `${year}/${month}/${day}`;
    case "yyyy/dd/mm":
      return `${year}/${day}/${month}`;
    case "yyyy-mm-dd":
      return `${year}-${month}-${day}`;
    case "yyyy-dd-mm":
      return `${year}-${day}-${month}`;
    case "dd-mm-yyyy":
      return `${day}-${month}-${year}`;
    case "mm-dd-yyyy":
      return `${month}-${day}-${year}`;
    default:
      return `${day}/${month}/${year}`;
  }
};

//convert in to this formate 35:41 Min
export const convertDurationToMinutes = (duration) => {
  const min = Math.floor(duration / 60);
  const sec = Math.floor(duration % 60);
  //add 0 if sec is less than 10 and also for min
  const secWithZero = sec < 10 ? `0${sec}` : sec;
  const minWithZero = min < 10 ? `0${min}` : min;
  return `${minWithZero} : ${secWithZero} Min`;
};

export const formateTimeStampDate = (timestamp) => {
  const date = new Date(timestamp);

  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric", // "2021"
    month: "short", // "Dec"
    day: "2-digit", // "14"
  });

  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit", // "09"
    minute: "2-digit", // "32"
    hour12: true, // AM/PM format
  });

  return `${formattedDate}, at ${formattedTime}`;
};

export const formatTimeStamp = (timestamp) => {
  const date = new Date(timestamp);

  const day = date.toLocaleDateString("en-US", { day: "2-digit" }); // "14"
  const month = date.toLocaleDateString("en-US", { month: "short" }); // "Dec"
  const year = date.toLocaleDateString("en-US", { year: "numeric" }); // "2021"

  return `${day}, ${month} ${year}`;
};

export const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds) % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")} min`;
};

export const downloadPlaylistImage = (image) => {
  if (!image) return;

  try {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = `${BASE_URL}/playlist_images/${image}`;
      img.crossOrigin = "anonymous";
      img.onload = () => {
        resolve(true);
      };
      img.onerror = () => {
        reject(false);
      };
    });
  } catch (error) {
    //
  }
};

export const downloadSongImage = (imageUrl) => {
  if (!imageUrl) return;

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imageUrl;
    img.crossOrigin = "anonymous";
    img.onload = () => {
      resolve(true);
    };
    img.onerror = () => {
      reject(false);
    };
  });
};
export const downloadDocument = async (transactionId) => {
  try {
    const blob = await userActions.downloadInvoice(transactionId);

    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `invoice-${transactionId}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return {
      success: true,
    };
  } catch (err) {
    toaster("error", err?.message || "Failed to download invoice");
    return {
      success: false,
    };
  }
};
